const trustedDomains = ['.strider.ag', '.cropwise.com', '.us-west-2.amazonaws.com'];

export const isTrustedDomain = (url: string): boolean => {
  if (!url.trim()) return false;
  try {
    const { protocol, hostname } = new URL(url);
    if (protocol !== 'https:') return false;
    return trustedDomains.some(domain => hostname.endsWith(domain));
  } catch {
    return false;
  }
};
